<template>
    <ElementLayout :parent="parent" :element="element">
    <div class="grey--text text--darken-2" style="display:flex" oldClass="{'text-align-right': element.align == 'right'}" >
        <div style="flex-grow:1">
            <div class="element-label">{{element.title}}</div>


            <SortableList :items="files" itemWidth="50%" style="padding:5px;border-radius:4px;">
                
                <template v-slot:default="{item: file}">
                    <div class="clickable" style="padding:2px 4px;margin:3px;display:flex;border-radius:8px;background-color:rgba(255,255,255,0.5); border:solid 1px #ddd">
                        <div class="pt-1 pr-1">
                            <v-icon large color="blue lighten-2">mdi-file-document-outline</v-icon>
                        </div>
                        <div style="font-size:12px;padding-top:3px">{{fileNameFromStoragePath(file.url)}}</div>
                    </div>
                </template>
                <template v-slot:menu="slotProps">
                    <v-list-tile @click="deleteFileFromGroup(slotProps.item)">
                        <v-list-tile-title>Delete this File</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="slotProps.selectedItems.length > 1" @click="deleteSelectedFiles(slotProps.selectedItems)">
                            <v-list-tile-title>Delete {{slotProps.selectedItems.length}} Selected</v-list-tile-title>
                    </v-list-tile>
                    <a :href="slotProps.item.url" class="transparent" target="_blank">
                        <v-list-tile @click="">
                            <v-list-tile-title>Open</v-list-tile-title>
                        </v-list-tile>
                    </a>
                </template>               
            </SortableList>

        </div>
    </div>  
    <template slot="right" v-if="!element.value">
        <UploadWrapper @click="doNothing" @select="uploadFiles">
            <v-btn outline :color="element.color" :disabled="element.disabled || uploading">
                <v-progress-circular v-if="uploading" size="24" indeterminate color="grey"></v-progress-circular>
                <span v-if="!uploading">Upload</span>
            </v-btn>
        </UploadWrapper>

    </template>
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import UploadWrapper from '@/ui-elements/UploadWrapper'
import FileHelpers from '@/helpers/FileHelpers'
import Firestore from '@/data/Firestore'
import Utilities from '../../helpers/Utilities'
import SortableList from '../../ui-elements/SortableList'
export default {
    data() {
        return {
          uploading: false,
        }
    },
    components: {
        ElementLayout,
        UploadWrapper,
        SortableList,
    },
    
    props: {
        element: Object,
        parent: Object,
    },
    computed: {
        storagePath() {
            return 'teams/' +  Firestore.shortPath(this.element._path) + '/' + this.element._id
        },
        files() {
            return Utilities.objectDeepGet(this, 'element/data/files')
        }
    },
    methods: {
        doNothing() {
            this.$set(this.element, 'disabled', true)
            setTimeout( () => {
                this.$set(this.element, 'disabled', false)
            }, 1000)
        },
        uploadFiles(files) {
            this.uploading = true
            FileHelpers.filesToFirebase(files, this.storagePath).then(fileGroup => {
                let newArrayValue = [...(Utilities.objectDeepGet(this, 'element/data/files') || []), ...fileGroup]
                Utilities.objectDeepSet(this, 'element/data/files', newArrayValue)
                // this.$set(this.element, 'value', newArrayValue)
                this.uploading = false
                this.updateFileCount()
            })
        },
        updateFileCount() {
            let files = Utilities.objectDeepGet(this, 'element/data/files') || []
            Utilities.objectDeepSet(this, 'element/value', files.length + ' files')
        },
        fileNameFromStoragePath(path) {
            return FileHelpers.fileNameFromStoragePath(path)
        },
        async deleteSelectedFiles(files) {
            let res = await this.$confirm('Are you sure you want to delete all selected files?')
            if(res)
                files.forEach(file => {
                    this.deleteFileFromGroup(file)
                })
        },
        deleteFileFromGroup(file) {
            FileHelpers.deleteFirebaseFile(file.url)
            // let idx = this.element.value.findIndex(o => o.url == file.url)
            let files = Utilities.objectDeepGet(this, 'element/data/files')
            let idx = files.findIndex(o => o.url == file.url)
            files.splice(idx,1)
            this.updateFileCount()
        },
        elementChanged(newVal) {
            this.$emit('change', {value: newVal, data:this.element.data, previousValue: this.originalValue})
            this.originalValue = newVal
        },
    },
    created() {
        
    }
}
</script>

<style scoped>
   .element-label{
       font-size:12px;
       color: #666;
   }
   .file-row {
       padding:5px;
       border-bottom: solid 1px #ddd;
   }
   .v-timeline-item.dense {
       padding-bottom:16px;
   }
</style>


// WEBPACK FOOTER //
// UploadControl.vue?0ee8bb7f